export default class Arith {
  // 去除千分位以及非数字的东西
  static delComma(arg1) {
    if (arg1 === undefined) {
      arg1 = 0;
    }
    if (Number(arg1) === Number(arg1)) return Number(arg1) || 0; // 传入的数字，则直接使用。
    var val = arg1.toString();
    return Number(val.replace(/[^\d.-]/g, "")) || 0;
  }

  // 加
  static add(arg1, arg2) {
    let r1,
      r2,
      m,
      n,
      v1 = this.delComma(arg1),
      v2 = this.delComma(arg2);
    try {
      r1 = v1.toString().split(".")[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = v2.toString().split(".")[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    //动态控制精度长度
    n = r1 >= r2 ? r1 : r2;
    let result = ((v1 * m + v2 * m) / m).toFixed(n);
    return Number(result);
  }

  // 减
  static sub(arg1, arg2) {
    let r1,
      r2,
      m,
      n,
      v1 = this.delComma(arg1),
      v2 = this.delComma(arg2);
    try {
      r1 = v1.toString().split(".")[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = v2.toString().split(".")[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    //动态控制精度长度
    n = r1 >= r2 ? r1 : r2;
    let result = ((v1 * m - v2 * m) / m).toFixed(n);
    return Number(result);
  }

  // 乘
  static mul(arg1, arg2) {
    let v1 = this.delComma(arg1),
      v2 = this.delComma(arg2),
      m = 0,
      s1 = v1.toString(),
      s2 = v2.toString();
    try {
      m += s1.split(".")[1].length;
    } catch (e) {}
    try {
      m += s2.split(".")[1].length;
    } catch (e) {}
    return (
      (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
      Math.pow(10, m)
    );
  }

  // 除
  static div(arg1, arg2) {
    let t1 = 0,
      t2 = 0,
      r1,
      r2,
      v1 = this.delComma(arg1),
      v2 = this.delComma(arg2);
    try {
      t1 = v1.toString().split(".")[1].length;
    } catch (e) {}
    try {
      t2 = v2.toString().split(".")[1].length;
    } catch (e) {}
    r1 = Number(v1.toString().replace(".", ""));
    r2 = Number(v2.toString().replace(".", ""));
    return (r1 / r2) * Math.pow(10, t2 - t1);
  }

  /**
   * 转千分位， 保留两位小数
   * @param s
   * @param p
   * @returns {string}
   */
  static thousandBit(num, precision, separator) {
    num = (num || 0) + "";
    if (precision === undefined) {
      precision = 2;
    }
    separator = separator || ",";
    num = num.replace(/,/g, "");
    var parts;
    // 判断是否为数字
    if (!isNaN(parseFloat(num.toString())) && isFinite(Number(num))) {
      // 把类似 .5, 5. 之类的数据转化成0.5, 5, 为数据精度处理做准, 至于为什么
      // 不在判断中直接写 if (!isNaN(num = parseFloat(num)) && isFinite(num))
      // 是因为parseFloat有一个奇怪的精度问题, 比如 parseFloat(12312312.1234567119)
      // 的值变成了 12312312.123456713
      num = Number(num);
      // 处理小数点位数
      num = (
        typeof precision !== "undefined" ? num.toFixed(precision) : num
      ).toString();
      // 分离数字的小数部分和整数部分
      parts = num.split(".");
      // 整数部分加[separator]分隔, 借用一个著名的正则表达式
      parts[0] = parts[0]
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + separator);
      return parts.join(".");
    }
    return "0.00";
  }

  /**
   * 精确四舍五入方法
   * @param value 原始数值
   * @param decimals 保留小数位数（默认2位）
   * @returns 四舍五入后的数值
   */
  static round(value = 0, decimals = 2) {
    value = Number(value);
    // 处理边界值
    if (!Number.isFinite(value)) return value;
    if (decimals < 0) decimals = 0;
    // 精度补偿
    const factor = Math.pow(10, decimals);
    // 分离符号处理（避免负数运算问题）
    const sign = value < 0 ? -1 : 1;
    const absoluteValue = Math.abs(value);
    // 精确计算流程
    const adjustedValue = absoluteValue * factor + Number.EPSILON;
    const truncated = Math.round(adjustedValue);
    // 重建最终结果
    return (sign * truncated) / factor;
  }

  /**
   * 删除千分位格式
   * @param s
   */
  static deleThousandBit(val) {
    if (val === void 0) {
      val = "";
    }
    val = String(val);
    val = val.replace(/,/g, ""); // 去掉千分位逗号
    val = val.replace(/\s/g, ""); // 去掉空格
    val = Number(val);
    if (!val) {
      // 0 或者 NaN就显示‘’
      val = "";
    }
    return val;
  }

  // 传入数组相加
  static addArray(numbers) {
    const sum = numbers.reduce((accumulator, currentValue) => {
      return Arith.add(accumulator, currentValue);
    }, 0);
    return sum;
  }

  // 传入数组相乘
  static mulArray(numbers) {
    if (!Array.isArray(numbers) || numbers.length === 0) return 0;
  
    // 利用 reduce 但减少内部调用层级
    return numbers.reduce((sum, num) => Arith.add(sum, num), 0);
  }
  // 计算字符串或者数字的大小，或者差值   不够精确
  static compareAndCalculate(str1, str2) {
    // 转换为数字
    const num1 = parseFloat(str1);
    const num2 = parseFloat(str2);
    // 计算差值
    const difference = num1 - num2;
    return difference;
  }
}
